export const messageCatalogModalContentKey: string = "MessageCatalogModalKey";